const isMobile = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  var jsonHeader = {
    'Content-Type': 'application/json',
    'User-Agent':  navigator.userAgent
  }

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isInStandaloneMode = () =>
  'standalone' in window.navigator && window.navigator.standalone;
const isPWA = window.matchMedia('(display-mode: standalone)').matches || isInStandaloneMode();

  export {isMobile, jsonHeader, isIOS, isPWA, isInStandaloneMode};
